module.exports = __webpack_public_path__ + "static/media/issue_update_icon4.55dd2097.svg";